import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@ipc/ipc-core';

const AppHeaderLeftContainer = () => (
  <div className="header-left-container">
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <div className="app-title">
      <Link to="/">
        <FormattedMessage id="app.title" tagName="h1" />
      </Link>
    </div>
  </div>
);

export default AppHeaderLeftContainer;
